import React, { useState, useEffect } from "react";
import "./styles.css";
import moment from "moment";
import {
  Tag,
  Button,
  Dropdown,
  Menu,
  Avatar,
  Row,
  Typography,
  Modal,
} from "antd";
import { MoreOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { updateNotes, getNotes, getReminders } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import MarkCompletedBtn from "./components/markCompletedBtn";
import NotesForm from "./components/notesForm";
import { LoadingOutlined } from "@ant-design/icons";

const Reminders = ({ res, index, fromDashboard }) => {
  const [selecteNote, setSelectedNote] = React.useState();
  const { Text } = Typography;
  const [imageError, setImageError] = useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [openCalendar, setOpenCalendar] = React.useState(false);
  const [openCalendarE, setOpenCalendarE] = useState(false);

  const dispatch = useDispatch();
  const Pdetails = useSelector(
    (state) => state.getProfileDetailsReducer.details
  );
  useEffect(() => {
    dispatch(getReminders({ id: res?.length > 0 && res.SkillListingId }));
  }, []);
  const deleteLoading = useSelector(
    (state) => state.getProfileDetailsReducer.loading
  );
  const handleOk = () => {
    dispatch(
      updateNotes({
        noteId: res?._id,
        Status: "deleted",
      })
	  );
	  
  };
  const editHandler = (e) => {
    if (e.key === "Edit") {
      setOpenModal(true);
    } else if (e.key === "Delete") {
      setDeleteModal(true);
    }
  };
  const menu = (
    <Menu className="joblisting-dropdown" onClick={editHandler}>
      <Menu.Item key="Edit">Edit</Menu.Item>

      <Menu.Item key="Delete">Delete</Menu.Item>
    </Menu>
  );

  //HOOKS

  return (
    <div
      className="notes-remonders-main"
      style={{ width: fromDashboard && "96%", margin: "auto" }}
    >
      <Modal
        title={null}
        open={openModal}
        footer={null}
        centered
        width={600}
		onCancel={() => {
			setOpenCalendarE(false);
			setTimeout(() => {
			  setOpenModal(false);
			  setOpenCalendar(false);
			}, [500]);
		  }}
      >
        <div>Edit note</div>
        <NotesForm
          data={Pdetails?.skill_listings}
          openModal={openModal}
          selecteNote={res}
          setOpenModal={setOpenModal}
		  onChageCal = {(val)=>setOpenCalendarE(val)}
          openCalendarV={openCalendarE}
        />
      </Modal>

      <Modal
        title={null}
        open={deleteModal}
        centered
        width={400}
        onCancel={() => {
          setDeleteModal(false);
        }}
        footer={[
          <>
            <Button
              onClick={() => {
                setDeleteModal(false);
              }}
              className="modal-no-btn"
            >
              No
            </Button>
            <Button onClick={handleOk} className="modal-ok-btn">
              {deleteLoading ? <LoadingOutlined /> : "Yes"}
            </Button>
          </>,
        ]}
      >
        <p>Do you want to delete the note?</p>
      </Modal>
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Row style={{ width: "70%" }}>
            {res?.SkillLitingUserPictureUrl && !imageError && res?.SkillLitingUserPictureUrl?.split("/")?.pop() !== "no-pic.png" ? (
              <Avatar
                className="reminders-avatar"
                src={`${process.env.REACT_APP_S3_URL}${
                  res?.SkillLitingUserPictureUrl?.charAt(0) !== "/" ? "/" : ""
                }${res?.SkillLitingUserPictureUrl}`}
                onError={() => {
                  setImageError(true);
                }}
              />
            ) : (
              <Text className="img-text-container">
                {res.SkillLitingUserFirstName
                  ? res.SkillLitingUserFirstName.split("")[0]
                      .charAt(0)
                      .toUpperCase()
                  : "C"}
              </Text>
            )}
            <div className="skill-user-details-div">
              <div>{`${res.SkillLitingUserFirstName} ${res.SkillLitingUserLastName}`}</div>
              <div>{res.SkillListingTitle}</div>
            </div>
          </Row>

          {res.Status === "completed" || res.Status === "Completed" ? (
            <Tag color="cyan" className="completed-tag">
              Completed
            </Tag>
          ) : (
            <MarkCompletedBtn res={res} editHandler={editHandler} />
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1.7%",
          }}
        >
          <div className="notes-text-main-container">
            <div className="notes-reminders-head">{`${res.NotesUserFirstName} ${res.NoteUserLastName}`}</div>
            <div className="notes-reminders-text">{res.Note}</div>
          </div>
          {res.Status === "completed" || res.status === "Completed" ? (
            <Tag color="cyan" className="completed-tag">
              Completed
            </Tag>
          ) : (
            !fromDashboard && (
              <div>
                <Button
                  className="notes-reminders-btn"
                  onClick={() => {
                    dispatch(
                      updateNotes({
                        noteId: res?._id,
                        Status: "completed",
                      })
                    );
                  }}
                >
                  Mark as Completed
                </Button>
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  onClick={() => {
                    // setSelectedNote(res)
                  }}
                >
                  <MoreOutlined />
                </Dropdown>
              </div>
            )
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
          className="notes-footer"
        >
          <div>
            {moment().diff(res?.NoteEndTime) < 0 ? (
              <>
                <Tag
                  icon={<ClockCircleOutlined />}
                  color="error"
                  className="reminders-tag-error"
                >
                  {moment(res.EndTime).format("MMMM DD, YYYY")}
                </Tag>
                <Tag className="overdue-tag">Overdue</Tag>
              </>
            ) : (
              <Tag
                icon={<ClockCircleOutlined />}
                color="default"
                className="reminders-tag"
                style={{ marginTop: "13%" }}
              >
                {res?.Status === "completed" || res?.status === "Completed" ? (
                  <del>{moment(res?.EndTime).format("MMMM DD, YYYY")}</del>
                ) : (
                  moment(res?.EndTime).format("MMMM DD, YYYY")
                )}
              </Tag>
            )}
          </div>
          <div>
            {
              <Button
                className="notes-reminders-btn2"
                onClick={() => {
                  dispatch(
                    updateNotes({
                      noteId: res?._id,
                      Status: "completed",
                    })
                  );
                }}
              >
                Mark as Completed
              </Button>
            }
          </div>
          <div
            className="notes-created-date-main"
            style={{ marginTop: "2%", color: "#7a6d6d", fontSize: "12px" }}
          >
            {moment(res?.NoteCreated).format("MMMM DD, YYYY")}
          </div>
        </div>
      </>
    </div>
  );
};
export default Reminders;
